function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Group = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "GroupIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("g", {
      opacity: ".6",
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.943 9.508a5.984 5.984 0 0 1 2.903-5.653A3.793 3.793 0 0 0 8.579 2c-2.093 0-3.79 1.684-3.79 3.762 0 2.078 1.697 3.763 3.79 3.763.123 0 .244-.006.364-.017zM9.668 11.893a3.816 3.816 0 0 1-3.238-.505c-.604-.414-1.317-.758-2.023-.565C1.617 11.587 1 13.19 1 14.717V18h3.912c.066-.97.34-2.062 1.087-3.07.876-1.18 2.224-2.006 4.012-2.491a5.988 5.988 0 0 1-.343-.546z"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M18.974 8.998C18.974 6.79 17.17 5 14.947 5c-2.223 0-4.026 1.79-4.026 3.998s1.803 3.997 4.026 3.997c2.224 0 4.027-1.79 4.027-3.997zm-8.388 5.357c.708-.188 1.42.153 2.017.577.66.47 1.47.748 2.344.748.878 0 1.69-.279 2.35-.752.595-.425 1.306-.766 2.013-.581 3.077.804 3.69 2.538 3.69 4.165V22H6.895v-3.488c0-1.635.665-3.353 3.691-4.157z",
      clipRule: "evenodd"
    })]
  }));
});
Group.displayName = 'GroupIcon';
export default Group;